// extracted by mini-css-extract-plugin
module.exports = {"grid":"RealGrid_grid__1Pozb"};